import {ClsPeticionPresupuestos} from './cls-pr-generico';
import {ClsErrores} from '../cls-errores';
import {ClsCostoHorarios} from '../cls-costo-horarios';

export class ClsPeticionUnCostoHorario extends ClsPeticionPresupuestos {
  IdCatalogoCostoHorario: bigint;
}

export class ClsRespuestaUnCostoHorario {
  LsCatalogo: ClsCostoHorarios[];
  Errores: ClsErrores;
}

export class ClsPeticionRegistraActualizaCostoHorario extends ClsPeticionPresupuestos {
  Catalogo: ClsCostoHorarios[];
}

export class ClsCostosHorariosStorageZip {
  CostosHorarios: string;
  CostosHorariosMO: string;
  CostosHorariosOC: string;
  Errores: ClsErrores;
}
